import _slicedToArray from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useRef, useMemo, useCallback } from "react";
import styled, { css } from "styled-components";
import useTheme from "../../hooks/useTheme";
import resolveContainerPosition from "../helpers/resolveContainerPosition";
import resolveTooltipArrowAlign from "../helpers/resolveTooltipArrowAlign";
import resolveTooltipArrowPosition from "../helpers/resolveTooltipArrowPosition";
import { StyledText } from "../../Text/index";
import { Item } from "../../List/ListItem/index";
import media from "../../utils/mediaQuery/index";
import tooltipSize from "../helpers/tooltipSize";
import resolveContainerAlign from "../helpers/resolveContainerAlign";
import tooltipArrowStyle from "../helpers/tooltipArrowStyle";
import tooltipPadding from "../helpers/tooltipPadding";
import defaultTheme from "../../defaultTheme";
import Button from "../../Button";
import Translate from "../../Translate";
import calculateTooltipPosition from "../helpers/calculateTooltipPosition";
import calculateTooltipAlign from "../helpers/calculateTooltipAlign";
import sortPositionsAndAligns from "../helpers/sortPositionsAndAligns";
import useDimensions from "../hooks/useDimensions";
var StyledTooltip = styled.div.withConfig({
  displayName: "TooltipContent__StyledTooltip",
  componentId: "sc-1umu28w-0"
})(["width:100%;"]);
var StyledTooltipWrapper = styled.div.withConfig({
  displayName: "TooltipContent__StyledTooltipWrapper",
  componentId: "sc-1umu28w-1"
})(["display:block;position:fixed;width:100%;box-sizing:border-box;border-top-left-radius:9px;border-top-right-radius:9px;background-color:", ";box-shadow:", ";padding:", ";visibility:", ";opacity:", ";transition:bottom ", " ease-in-out,visibility ", " linear ", ";z-index:10012;bottom:", ";left:0;right:0;max-height:", ";overflow-y:scroll;img{max-width:100%;}", ";&::after{width:0;height:0;border-style:solid;content:\" \";display:none;position:absolute;", ";", ";", ";", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.orbit.backgroundTooltip;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.orbit.boxShadowRaisedReverse;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.orbit.spaceMedium;
}, function (_ref4) {
  var shownMobile = _ref4.shownMobile;
  return shownMobile ? "visible" : "hidden";
}, function (_ref5) {
  var shownMobile = _ref5.shownMobile;
  return shownMobile ? "1" : "0";
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.orbit.durationNormal;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.orbit.durationFast;
}, function (_ref8) {
  var shownMobile = _ref8.shownMobile,
      theme = _ref8.theme;
  return !shownMobile && theme.orbit.durationNormal;
}, function (_ref9) {
  var shownMobile = _ref9.shownMobile,
      tooltipWidth = _ref9.tooltipWidth;
  return shownMobile ? "0" : "-".concat(tooltipWidth, "px");
}, function (_ref10) {
  var theme = _ref10.theme;
  return "calc(100% - ".concat(theme.orbit.spaceXLarge, ")");
}, media.largeMobile(css(["max-height:none;overflow:visible;width:auto;position:absolute;max-width:", ";border-radius:", ";padding:", ";background-color:", ";visibility:", ";opacity:", ";transition:opacity ", " ease-in-out,visibility ", " ease-in-out;box-shadow:", ";top:auto;right:auto;bottom:auto;left:auto;", ";", ";"], tooltipSize, function (_ref11) {
  var theme = _ref11.theme;
  return theme.orbit.borderRadiusNormal;
}, tooltipPadding, function (_ref12) {
  var theme = _ref12.theme;
  return theme.orbit.backgroundTooltipLargeMobile;
}, function (_ref13) {
  var shown = _ref13.shown;
  return shown ? "visible" : "hidden";
}, function (_ref14) {
  var shown = _ref14.shown;
  return shown ? "1" : "0";
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.orbit.durationFast;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.orbit.durationFast;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.orbit.boxShadowRaised;
}, resolveContainerPosition, resolveContainerAlign)), tooltipArrowStyle, resolveTooltipArrowPosition, resolveTooltipArrowAlign, media.largeMobile(css(["display:block;"])));
StyledTooltipWrapper.defaultProps = {
  theme: defaultTheme
};
var StyledTooltipContent = styled.div.withConfig({
  displayName: "TooltipContent__StyledTooltipContent",
  componentId: "sc-1umu28w-2"
})(["font-family:", ";font-size:", ";font-weight:", ";line-height:", ";color:", ";margin-bottom:16px;& ", ",", "{font-size:", ";font-weight:", ";color:", ";}", ";"], function (_ref18) {
  var theme = _ref18.theme;
  return theme.orbit.fontFamily;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.orbit.fontSizeTextNormal;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.orbit.fontWeightNormal;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.orbit.lineHeightTextNormal;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.orbit.paletteInkNormal;
}, StyledText, Item, function (_ref23) {
  var theme = _ref23.theme;
  return theme.orbit.fontSizeTextNormal;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.orbit.fontWeightNormal;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.orbit.paletteInkNormal;
}, media.largeMobile(css(["color:", ";font-size:", ";font-weight:", ";margin-bottom:0;& ", ",", "{color:", ";font-weight:", ";font-size:", ";}"], function (_ref26) {
  var theme = _ref26.theme;
  return theme.orbit.paletteWhite;
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.orbit.fontSizeTextSmall;
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.orbit.fontWeightMedium;
}, StyledText, Item, function (_ref29) {
  var theme = _ref29.theme;
  return theme.orbit.paletteWhite;
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.orbit.fontWeightMedium;
}, function (_ref31) {
  var theme = _ref31.theme;
  return theme.orbit.fontSizeTextSmall;
})));
StyledTooltipContent.defaultProps = {
  theme: defaultTheme
};
var StyledTooltipClose = styled.div.withConfig({
  displayName: "TooltipContent__StyledTooltipClose",
  componentId: "sc-1umu28w-3"
})(["", ""], media.largeMobile(css(["display:none;visibility:hidden;"])));
StyledTooltipClose.defaultProps = {
  theme: defaultTheme
};
var StyledTooltipOverlay = styled.div.withConfig({
  displayName: "TooltipContent__StyledTooltipOverlay",
  componentId: "sc-1umu28w-4"
})(["position:fixed;display:block;visibility:", ";width:100%;height:100%;top:0;right:0;bottom:0;left:0;background-color:rgba(23,27,30,0.6);z-index:10011;opacity:", ";transition:opacity ", " ease-in-out,visibility ", " linear ", ";", ";"], function (_ref32) {
  var shownMobile = _ref32.shownMobile;
  return shownMobile ? "visible" : "hidden";
}, function (_ref33) {
  var shownMobile = _ref33.shownMobile;
  return shownMobile ? "1" : "0";
}, function (_ref34) {
  var theme = _ref34.theme;
  return theme.orbit.durationNormal;
}, function (_ref35) {
  var theme = _ref35.theme;
  return theme.orbit.durationFast;
}, function (_ref36) {
  var shownMobile = _ref36.shownMobile,
      theme = _ref36.theme;
  return !shownMobile && theme.orbit.durationNormal;
}, media.largeMobile(css(["display:none;visibility:hidden;"])));
StyledTooltipOverlay.defaultProps = {
  theme: defaultTheme
};

var TooltipContent = function TooltipContent(_ref37) {
  var dataTest = _ref37.dataTest,
      shownMobile = _ref37.shownMobile,
      shown = _ref37.shown,
      size = _ref37.size,
      tooltipId = _ref37.tooltipId,
      children = _ref37.children,
      onClose = _ref37.onClose,
      onCloseMobile = _ref37.onCloseMobile,
      onEnter = _ref37.onEnter,
      preferredPosition = _ref37.preferredPosition,
      containerRef = _ref37.containerRef;
  var theme = useTheme();
  var overlay = useRef(null);
  var tooltip = useRef(null);
  var content = useRef(null);

  var _useMemo = useMemo(function () {
    return sortPositionsAndAligns(preferredPosition, theme);
  }, [preferredPosition, theme]),
      _useMemo2 = _slicedToArray(_useMemo, 2),
      positions = _useMemo2[0],
      aligns = _useMemo2[1];

  var dimensions = useDimensions({
    containerRef: containerRef,
    tooltip: tooltip,
    content: content
  }, children);
  var position = useMemo(function () {
    return calculateTooltipPosition(positions, dimensions);
  }, [dimensions, positions]);
  var align = useMemo(function () {
    return calculateTooltipAlign(position, aligns, dimensions);
  }, [aligns, dimensions, position]);
  var handleClickOutside = useCallback(function (ev) {
    ev.stopPropagation();

    if (ev.target === overlay.current) {
      onCloseMobile();
    }
  }, [onCloseMobile]);
  return React.createElement(StyledTooltip, {
    "data-test": dataTest
  }, React.createElement(StyledTooltipOverlay, {
    shownMobile: shownMobile,
    ref: overlay,
    onClick: handleClickOutside
  }), React.createElement(StyledTooltipWrapper, {
    shown: shown && position && align,
    shownMobile: shownMobile,
    size: size,
    align: align,
    position: position,
    ref: tooltip,
    containerTop: dimensions.containerTop,
    containerLeft: dimensions.containerLeft,
    containerHeight: dimensions.containerHeight,
    containerWidth: dimensions.containerWidth,
    tooltipHeight: dimensions.tooltipHeight,
    tooltipWidth: dimensions.tooltipWidth,
    contentHeight: dimensions.contentHeight,
    role: "tooltip",
    "aria-hidden": !shown && !shownMobile,
    id: tooltipId,
    onMouseEnter: onEnter,
    onMouseLeave: onClose
  }, React.createElement(StyledTooltipContent, {
    ref: content
  }, children), React.createElement(StyledTooltipClose, null, React.createElement(Button, {
    type: "secondary",
    fullWidth: true,
    onClick: onCloseMobile
  }, React.createElement(Translate, {
    tKey: "button_close"
  })))));
};

export default TooltipContent;